import { AccountingProvider, PayrollProvider, TicketingProvider } from '../graphql';
import { isTicketingTokenConnected } from '../utils/ticketing-token.utils';
import { useProviderTokensAndSyncedProviders } from './useProviderTokensAndSyncedProviders';

type DisableCondition = 'token' | 'sync';

export const useDisabledProviders = ({
  disableConditions: { accounting = 'token', payroll = 'token' } = {},
  fiscalYearId,
}: {
  disableConditions?: { accounting?: DisableCondition; payroll?: DisableCondition };
  fiscalYearId: string;
}): {
  disabledAccountingProviders: AccountingProvider[];
  disabledPayrollProviders: PayrollProvider[];
  disabledTicketingProviders: TicketingProvider[];
} => {
  const { accountingTokens, payrollTokens, syncedProviders, ticketingTokens } = useProviderTokensAndSyncedProviders({
    fiscalYearId,
  });
  const { accountingProviders, payrollProviders } = syncedProviders || {};

  return {
    disabledAccountingProviders:
      accounting === 'token'
        ? accountingTokens?.map(({ accountingProvider }) => accountingProvider) || []
        : accountingProviders?.map(({ providerName }) => providerName) || [],
    disabledPayrollProviders:
      payroll === 'token'
        ? payrollTokens?.map(({ payrollProvider }) => payrollProvider) || []
        : payrollProviders?.map(({ providerName }) => providerName) || [],
    disabledTicketingProviders:
      ticketingTokens?.filter(isTicketingTokenConnected).map(({ ticketingProvider }) => ticketingProvider) || [],
  };
};
